import axios from 'axios';

const BASE_URL = '/app/appointmentFunnel';

export const create = async () => {
    const { data } = await axios.post(BASE_URL);

    return data;
};

export const updateAppointment = async (appointmentId, payload) => {
    try {
        const { data } = await axios.put(`${BASE_URL}/${appointmentId}`, payload);

        return data;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error updating appointment:', error);
        throw error;
    }
};

export const edit = async (appointmentId) => {
    const {
        data: {
            appointmentType,
            appointmentTypeItems,
            allUsersMap,
            appointmentTitle,
            appointmentBody,
            assignToOwner,
            backupAssignTo,
            notifyOwner,
            notifyIds,
            appointmentDelayFieldsDto,
        },
    } = await axios.post(`${BASE_URL}/async/edit/${appointmentId}`);

    return {
        appointmentType,
        appointmentTypeItems,
        allUsersMap,
        appointmentTitle,
        appointmentBody,
        assignToOwner,
        backupAssignTo,
        notifyOwner,
        notifyIds,
        appointmentDelayFieldsDto,
    };
};
